import { render, staticRenderFns } from "./ScientificDegreeCards.vue?vue&type=template&id=17dc7b67&"
import script from "./ScientificDegreeCards.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports